import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["trackId", "lessonId", "playlistId", "shortId", "language", "onShareOptionClick"];
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import { SocialShareList } from '..';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialShareDropdown = _ref => {
  let {
      trackId,
      lessonId,
      playlistId,
      shortId,
      language,
      onShareOptionClick
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(UIDropdown, Object.assign({
    buttonSize: "sm",
    buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.common.share"
    }),
    buttonUse: "tertiary"
  }, props, {
    children: /*#__PURE__*/_jsx(SocialShareList, {
      language: language,
      lessonId: lessonId,
      onClick: onShareOptionClick,
      playlistId: playlistId,
      shortId: shortId,
      trackId: trackId
    })
  }));
};
export default SocialShareDropdown;